module.exports = __webpack_public_path__ + "img/resources-1440.d97b6e1d.jpg";